import React from 'react';
import PropTypes from 'prop-types';
import { useField } from 'formik';
import { Form, Select, Input } from 'antd';

const { Option } = Select;

function InputPrefixField(props) {
  const { name, label, type, data, formItemLayout, ...restInputProps } = props;
  // eslint-disable-next-line
  const [field, meta, helpers] = useField(name);

  const selector = (
    <Form.Item name="suffix" noStyle>
      <Select style={{ width: 70 }}>
        {data.map(({ value, label }) => (
          <Option key={value} value={value}>
            {label}
          </Option>
        ))}
      </Select>
    </Form.Item>
  );

  return (
    <Form.Item
      {...formItemLayout}
      label={label}
      // hasFeedback
      help={meta.touched && meta.error}
      validateStatus={meta.touched && meta.error && 'error'}
    >
      <Input {...field} {...restInputProps} addonAfter={selector} style={{ width: '100%' }} />
    </Form.Item>
  );
}

InputPrefixField.defaultProps = {
  data: [],
  formItemLayout: {
    labelCol: {
      span: 24,
    },
    wrapperCol: {
      span: 24,
    },
  },
};

const { shape, string, array } = PropTypes;

InputPrefixField.propTypes = {
  name: string.isRequired,
  label: string,
  data: array,
  formItemLayout: shape({}),
};

export default InputPrefixField;
